import React from 'react';
import MasterLayout from '../masterLayout/MasterLayout';
import PurchasingInventoryReferencesLayer from '../components/PurchasingInventoryReferencesLayer';

const PurchasingInventoryReferencesPage = () => (
  <MasterLayout pageTitle='Inventory Reference Tables'>
    <PurchasingInventoryReferencesLayer />
  </MasterLayout>
);

export default PurchasingInventoryReferencesPage;
